import { createContext } from 'react';
import { useDefinedContext } from '@/src/utils/context/useDefinedContext';
import { SessionStore } from '@/src/features/app/store/session/store';

export const SessionContext = createContext<SessionStore | undefined>(undefined);

export const useSessionContext = (): SessionStore => useDefinedContext(SessionContext);
